var complimentaryGiftID = "8193881407540"; //Complimentary Gift Variant ID
// Get the modal
var pModal = document.getElementById('productModal');
// Get the button that opens the modal
var btn = document.getElementById("myBtn");
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

$(function(){
  var $template = $('#js_template').val();

  // When the user clicks the button, open the modal
  $('.promo_banner').click(function(){
    pModal.style.display = "block";
  })
  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    pModal.style.display = "none";
  }
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == pModal) {
      pModal.style.display = "none";
    }
  }

  if($template == 'product') {
    // When the user clicks the button, open the modal
    $('#myBtn').click(function(){
      pModal.style.display = "block";
    })
  }

  setTimeout(function(){
    $('.js-instafeed').flickity({
      wrapAround: true
    });

  },1000)

  if ($(window).width() <= 768) {
    var targeted = $('ul#mobile_menu').children().first().children().first();
    // console.log(targeted);
//     targeted.html('Shop <span class="right icon-down-arrow"></span>'); //Commented out by Andy on 20190630, it is not required to hardcode the mobile menu.
  }


})
if ($(window).width() <= 1023 ){
  //Sort by
  $(".mobile_sticky_js_one").stick_in_parent({
    offset_top: 100
  })
  .on("sticky_kit:stick", function(e) {
    // console.log("has stuck!", e.target);
    $(e.target).css('top','90px');
    $(e.target).css('z-index',99);
  })
  .on("sticky_kit:unstick", function(e) {
    // console.log("has unstuck!", e.target);
  });

  //Filter
  $(".mobile_sticky_js_two").stick_in_parent({
    offset_top: 200
  })
  .on("sticky_kit:stick", function(e) {
    // console.log("has stuck!", e.target);
    $(e.target).css('top','133px');
    $(e.target).css('z-index',99);
    $(e.target).css('background','#ffffff');
  })
  .on("sticky_kit:unstick", function(e) {
    // console.log("has unstuck!", e.target);
  });
}

$(window).on('pageshow', function(){
  // Only happen on cart page
  if(window.location.href.indexOf("cart") > -1) {
     // Clear cart which contain the complimentaryGiftID
     if (window.location.href.substr(-2) !== '?r') {
       setTimeout(function(){
         window.location = window.location.href + '?r';
       },2);
     }
     CartJS.removeItemById(complimentaryGiftID);
  }

});

function getQuantityForGift(evt, item_count){
  if($('#cart_agree').prop('checked') == true){
    CartJS.addItem(complimentaryGiftID, item_count);
  }

  setTimeout(function(){
    $('#checkout').click();
  },1000);

}
